import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import { useNavigate } from 'react-router-dom';
import BackIcon from 'assets/icons/ic-back.svg';
import styled from 'styled-components';
import React from 'react';

interface BreadcrumbsProps {
  pageTitle: string | React.ReactElement;
  breadcrumbsTitle: string | React.ReactElement;
}

const BreadcrumbsColumn = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    margin: ['24px 12px', '24px 12px', '24px 0']
  })
);

const StyledRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    '&:hover': {
      cursor: 'pointer',
      path: {
        fill: theme.styleguideColors.fillPrimaryBlueHover
      },
      color: theme.styleguideColors.fillPrimaryBlueHover
    }
  })
);

const StyledPageTitle = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '32px'
  })
);

export const Breadcrumbs = ({ pageTitle, breadcrumbsTitle }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <BreadcrumbsColumn gap={8}>
      <StyledRow onClick={handleBack} align="center" gap={8}>
        <SvgIcon src={BackIcon} width={11} height={12} />
        <BodyText size={1} variation={'blue'} scale={'sm'}>
          {breadcrumbsTitle}
        </BodyText>
      </StyledRow>
      <StyledPageTitle>{pageTitle}</StyledPageTitle>
    </BreadcrumbsColumn>
  );
};
